import { Guid } from 'guid-typescript'
import { cloneDeep } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'

import { TagData } from '../../../../Tags/types'

export type BaseButtonProps<T = { [key: string]: any }> = {
  i18n: i18n
  tags?: () => Array<TagData>
} & T

export default abstract class Button {
  $i18n: i18n

  title: string | null = null

  abstract setupView: typeof Vue
  abstract buttonView: typeof Vue
  abstract name: string

  /**
   * В дате хранятся все редактируемые поля для передачи ее в setupView и создания структуры.
   * При редактировании в setupView будет передана вся структура
   */
  data: { text: string } & { [key: string]: any }

  propsData: { [key: string]: any } | null = null

  structBuilder: typeof ButtonStruct = ButtonStruct

  icon: string | null = null

  constructor(props: BaseButtonProps) {
    this.$i18n = props.i18n

    if (props.tags) {
      const { i18n, ...otherFields } = props

      this.propsData = otherFields
    } else {
      this.propsData = props
    }

    this.data = this.getRawData()
  }

  create(): ButtonStruct {
    const struct = new this.structBuilder({
      ...cloneDeep(this.data),
      guid: Guid.create().toString(),
      type: this.name,
    })
    this.refreshData()

    return struct
  }

  abstract getRawData(arg?: any): { text: string } & { [key: string]: any }

  refreshData(): void {
    this.data = this.getRawData()
  }
}

export class ButtonStruct {
  guid: string
  type: string
  text: string

  constructor({ type, text, guid }: { type: string, text: string, guid?: string }) {
    this.type = type
    this.text = text
    this.guid = guid ?? Guid.create().toString()
  }
}
